
const MetricsSection = () => {
  const metrics = [
    {
      title: 'Faster lead response and higher conversion',
      icon: 'ri-speed-up-line',
      stat: '3x',
      label: 'Faster Response'
    },
    {
      title: 'Reduced administrative workload',
      icon: 'ri-time-line',
      stat: '60%',
      label: 'Time Saved'
    },
    {
      title: 'Improved client and patient experience',
      icon: 'ri-user-heart-line',
      stat: '95%',
      label: 'Satisfaction'
    },
    {
      title: 'Clear operational visibility and control',
      icon: 'ri-dashboard-line',
      stat: '100%',
      label: 'Visibility'
    }
  ];

  return (
    <section className="py-32 bg-zinc-950 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, #10B981 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <span className="text-emerald-400 text-xs font-semibold uppercase tracking-widest mb-4 block">
            CLIENT OUTCOMES
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            What Clients Typically See
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {metrics.map((metric, index) => (
            <div 
              key={index}
              className="group relative bg-zinc-900/80 backdrop-blur-sm border border-zinc-800 rounded-2xl p-8 hover:border-emerald-500/40 transition-all duration-300 text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-emerald-500/10 rounded-2xl mx-auto mb-6 group-hover:bg-emerald-500/20 transition-colors">
                <i className={`${metric.icon} text-3xl text-emerald-400`}></i>
              </div>
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400 mb-2">
                {metric.stat}
              </div>
              <div className="text-sm text-emerald-400 font-semibold mb-4">{metric.label}</div>
              <p className="text-gray-300 text-sm leading-relaxed">
                {metric.title}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="inline-block px-8 py-4 bg-zinc-900/50 border border-zinc-800 rounded-xl">
            <p className="text-gray-300 text-lg">
              Every system includes performance tracking and optimization pathways.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MetricsSection;
